import React, { useState, useEffect } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import {serverTimestamp, setDoc, doc, collection, query, where, writeBatch, onSnapshot, getDocs, orderBy } from "firebase/firestore";
import { auth, db, storage, messaging } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import WarningAmber from '@mui/icons-material/WarningAmber';
import Icon from '@mui/material/Icon';
import { Select, MenuItem, FormControl, InputLabel, TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


// import { functions } from '../../../firebase'


import { httpsCallable, getFunctions } from 'firebase/functions';


const New = () => {

  const [file, setFile ] = useState("")
  // const [ data, setData ] = useState({})
  const [title, setTitle] = useState("")
  const [body, setBody] = useState("")
  const [allUsers, setAllUsers] = useState([])
  const [user, setUser] = useState("")
  const [token , setToken ] = useState("ExponentPushToken[TPrPLHLBgrnidfV2HRHSJE]")
  const [plan, setPlan ] = useState("")
  const [premiumList, setPremiumList] = useState([])
  const [platinumList, setPlatinumList] = useState([])
  const [standardList, setStandardList] = useState([])
  const [icon, setIcon] = React.useState('');
  const [iconColor, setIconcolor] = useState("")
  const [isloading, setIsloading ] = useState(false)
  const [titleError, setTitleError] = useState("")
  const [bodyError, setBodyError] = useState("")

  const today = new Date().toDateString()

  const navigate = useNavigate();


  const Spinner = () => {
    return(
      <span className='spinner-container'>
          <span className='loading-spinner'></span>
      </span>
    )
  }


  useEffect(() => {

    const fetchUsers = async () => {

      try {

        const querySnapshot = await getDocs(collection(db, 'users'), orderBy('firstname', 'desc'));

        const usersData = querySnapshot.docs.map(doc => ({

          id: doc.id,
          
          ...doc.data()

        }));

        setAllUsers(usersData);

      } catch (error) {

        console.error('Error fetching users:', error);

      }

    };

    fetchUsers();

  }, [db]);

  

  const handleChange = (event) => {
    setPlan(event.target.value);
  };



  const handleSingleNotification = async(e) => {

    e.preventDefault()

    if(title === "") {
      return setTitleError('title is required')
      
    }

     if(body === "") {
      return setBodyError('body is required')
      
    }

      setIsloading(true)

      try {

          const functions = getFunctions();
          const sendSingleNotification = httpsCallable(functions, 'sendSingleNotifications');
          const result = await sendSingleNotification({recipientId: user, title: title, body: body});


          if(result.data.success === true){

            setIsloading(false)
          
            alert(result.data.messageId)

            navigate('/individual')

          }

          // alert(result.data.messageId)

          // console.log(result.data.messageId);

          setIsloading(false)

      } catch (error) {

          console.error('Error requesting:', error);

      }finally{

           setIsloading(false)

      }

   
       
  }



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Group Notification</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/messages"
            >
              Notification List
            </Link>
            <Typography color="green">New Notification</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
          <div className='right'>
            <div className='form' onSubmit={handleSingleNotification}>

                   {/* <Box sx={{ minWidth: '50%' }}>
                    <FormControl fullWidth>
                    <InputLabel id="user" style={{color:'#999', fontWeight:300}}>Select User</InputLabel>
                    <Select
                      labelId="user"  
                      id="user"
                      value={user}
                      label="User"
                      onChange={handleChange}         
                    >

                      {allUsers.map((item) => { 

                        return(

                          <MenuItem value={item.id}>{item.firstname}- {item.lastname}</MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                    </Box> */}

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'50%', marginBottom:0, marginRight:0}}>
                    <TextField
                      id="title"
                      onChange={(e) => setTitle(e.target.value)}
                      value = {title}
                      placeholder="Enter Title"
                      style={{width:'100%'}}

                    />

                    {titleError &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {titleError}</p>
                    }
                    
                  </div>

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'50%', marginBottom:0, marginRight:0}}>

                    <TextField
                      id="message" 
                      value={body}
                      multiline
                      minRows={3}
                      maxRows={10}
                      placeholder="Enter Message"
                      style={{width:'100%'}}
                      onChange={(e) => setBody(e.target.value)}
                    />

                     {bodyError &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {bodyError}</p>
                    }

                    </div>


                    <Button onClick={handleSingleNotification} style={{width:'50%', backgroundColor:'rgb(15, 31, 175)'}}>{isloading ? '...loading' : 'Send Notification'}</Button>


            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default New
